'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var withoutWhitespaces = function withoutWhitespaces(string) {
  return string.replace(/\s/g, '');
};

var substringFrom = function substringFrom(string, start) {
  return string.substring(string.indexOf(start) + start.length);
};

var substringTo = function substringTo(string, end) {
  return string.substring(0, string.indexOf(end));
};

var head = function head(string) {
  return string[0];
};

var last = function last(string) {
  return string[string.length - 1];
};

exports.withoutWhitespaces = withoutWhitespaces;
exports.substringFrom = substringFrom;
exports.substringTo = substringTo;
exports.head = head;
exports.last = last;